import { Pagination } from "@/components/molecules/Pagination";
import {
  OperationPlanOrder,
  OperationPlanSortKey,
  OperationPlansPerEvCar,
} from "@/models/operationPlans";
import {
  getAllDateAttributes,
  OperationPlansConstansts,
  sticky,
} from "@/pages/OperationPlans/OperationPlansConstansts";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useMemo } from "react";
import { TableSortLabel } from "../atoms/TableSortLabel";
import { Rows } from "./OperationPlansRow";

interface OperationPlansListProps {
  operationPlans: OperationPlansPerEvCar[];
  targetMonth: string;
  total: number;
  page: number;
  size: number;
  orderType: OperationPlanOrder;
  clickable: boolean;
  focusDate: Date;
  focusDateColumnRef: React.Ref<HTMLElement | null>;
  onClickPlan: (planId: number) => void;
  onChangePage: (page: number) => void;
  onClickChangeSort: (key: OperationPlanSortKey) => void;
}
export const OperationPlansList = ({
  operationPlans,
  targetMonth,
  page,
  total,
  size,
  orderType,
  clickable,
  focusDate,
  focusDateColumnRef,
  onClickPlan,
  onClickChangeSort,
  onChangePage,
}: OperationPlansListProps) => {
  const focusDateStr = useMemo(
    () => `${focusDate.getMonth() + 1}/${focusDate.getDate()}`,
    [focusDate]
  );

  const filterdPlans = useMemo(
    () =>
      operationPlans.map((row) => ({
        ...row,
        carOperationPlansDisplay: row.carOperationPlansDisplay.filter(
          ({ targetDate }) => new Date(targetDate) >= new Date(row.usageStartOn)
        ),
      })),
    [operationPlans]
  );

  const { dateLabels, dateTypeLabels } = useMemo(
    () => getAllDateAttributes(targetMonth),
    [targetMonth]
  );

  return (
    <React.Fragment>
      <TableContainer
        sx={{ width: "100%", overflowX: "auto", backgroundColor: "#FFF" }}
        className="table-container-width"
      >
        <Table
          size="small"
          sx={{ width: "100%", overflowX: "auto" }}
          className="list-head"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "white" }}>
              <TableCell
                colSpan={2}
                className="body-none-custom"
                sx={{ ...sticky, left: 0, textAlign: "center" }}
              />
              {dateLabels.map((dateLabel) => {
                return (
                  <TableCell
                    key={dateLabel}
                    className="width-100 body-none-custom padding-left-right-none"
                    sx={{
                      textAlign: "center",
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    }}
                    ref={
                      dateLabel === focusDateStr
                        ? focusDateColumnRef
                        : undefined
                    }
                  >
                    {dateLabel}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow sx={{ backgroundColor: "white" }}>
              <TableCell
                className="padding-left-right-none"
                width={240}
                sx={{
                  ...sticky,
                  left: 0,
                  width: 240,
                  minWidth: 240,
                  maxWidth: 240,
                  textAlign: "center",
                }}
              >
                {OperationPlansConstansts.OfficeName}
                <TableSortLabel
                  active={
                    operationPlans.length > 0 && !!orderType["officeName"]
                  }
                  direction={
                    orderType["officeName"] === "desc" ? "desc" : "asc"
                  }
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("officeName")}
                />
              </TableCell>
              <TableCell
                sx={{
                  ...sticky,
                  left: 240,
                  width: 130,
                  minWidth: 130,
                  maxWidth: 130,
                  textAlign: "center",
                }}
              >
                {OperationPlansConstansts.RadioNumber}
                <TableSortLabel
                  active={
                    operationPlans.length > 0 && !!orderType["vehicleCode"]
                  }
                  direction={
                    orderType["vehicleCode"] === "desc" ? "desc" : "asc"
                  }
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("vehicleCode")}
                />
              </TableCell>
              {dateTypeLabels.map((dateTypeLabel, index) => {
                return (
                  <TableCell
                    key={dateTypeLabel + index}
                    className="width-100 padding-left-right-none"
                    sx={{
                      textAlign: "center",
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    }}
                  >
                    {dateTypeLabel}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            <Rows
              plans={filterdPlans}
              dateLabels={dateLabels}
              clickable={clickable}
              onClickPlan={onClickPlan}
            />
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={total}
        page={page}
        size={size}
        setPage={onChangePage}
      />
    </React.Fragment>
  );
};
